<template>
	<div id="energyRightTop">
		<dv-border-box-6>
			<div class="d-flex pt-2 pl-2">
				<div class="d-flex">
					<span class="mt-3 ml-3 title_t">用能变化</span>
				</div>
			</div>
			<div class="d-flex box-head pt-3">
				<el-button :type="isYear ? 'primary' : ''" class="ml-4 float-l" @click="changeYear">年</el-button>
				<el-button :type="!isYear ? 'primary' : ''" class="ml-5 float-l" @click="changeMonth">月</el-button>
				<div class="block float-l ml-5" v-if="isYear">
					<el-date-picker v-model="value1" type="year" value-format="yyyy" placeholder="选择年"></el-date-picker>
				</div>
				<div class="block float-l ml-5" v-else>
					<el-date-picker v-model="value2" type="month" value-format="yyyy-MM" placeholder="选择月"></el-date-picker>
				</div>
				<el-button type="primary" size="medium" @click="timeChange">查询</el-button>
			</div>
			<div class="box-content pt-5 d-flex jc-around">
				<div class="left pl-2">
					<div>
						<p class="pb-3">合计用能</p>
						<span class="show">{{ showData.total_dnsj }}</span>
						<span class="ml-3">度</span>
					</div>
					<div class="list mt-5">
						<div>
							<span class="listText">空调用能</span>
							<span class="show">{{ showData.air_dnsj }}</span>
							<span class="ml-3">度</span>
						</div>
						<div>
							<span class="listText">水泵用能</span>
							<span class="show">{{ showData.pump_dnsj }}</span>
							<span class="ml-3">度</span>
						</div>
						<div>
							<span class="listText">冷却塔用能</span>
							<span class="show">{{ showData.cooling_dnsj }}</span>
							<span class="ml-3">度</span>
						</div>
					</div>
				</div>
				<div class="right">
					<div id="energyRightLine" style="width: 100%; height: 3.9rem;"></div>
				</div>
			</div>
		</dv-border-box-6>
	</div>
</template>

<script>
	import echarts from "echarts"
	export default {
		components: {

		},
		data() {
			return {
				chart: null,
				isYear: true,
				value1: String(this.getNowTime()),
				value2: '',
				chartData: [],
				showData: {},
			};
		},
		props: ['building'],
		watch: {
			'building': {
				handler() {
					this.energyChange();
				},
			}
		},
		mounted() {
			this.energyChange();
		},
		methods: {
			timeChange() {
				this.energyChange();
			},
			async energyChange() {
				let dataObj = {}
				if(this.isYear){
					dataObj = {
						building_id: this.building,
						year: this.value1,
					}
				}else{
					dataObj = {
						building_id: this.building,
						month: this.value2,
					}
				}
				await this.$axios.get("/api/buildings/energyChange", {
					params: dataObj
				}).then(res => {
					let total_dnsj = res.data.data.sum.air_dnsj + res.data.data.sum.pump_dnsj + res.data.data.sum.cooling_dnsj
					res.data.data.sum.total_dnsj = total_dnsj
					this.showData = res.data.data.sum
					
					let timeData = []
					let airData = []
					let pumpData = []
					let coolingData = []
					for(let item of res.data.data.daily_energy){
						if(this.isYear){
							timeData.push(item.add_time.substr(5,2))
						}else{
							timeData.push(item.add_time.substr(8,2))
						}
						airData.push(item.air_dnsj)
						pumpData.push(item.pump_dnsj)
						coolingData.push(item.cooling_dnsj)
					}
					this.chartData = [timeData, airData, pumpData, coolingData]
					this.draw()
				})
			},
			draw() {
				// 基于准备好的dom，初始化echarts实例
				this.chart = this.$echarts.init(
					document.getElementById("energyRightLine"), 'dark'
				);
				let that = this;
				let option = {
					backgroundColor: 'rgb(255,255,255,0)', //背景色
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						formatter: function(params) {
							let showText = '';
							if(that.isYear){
								showText = params[0].name + '月' + "<br />" +
								'空调：' + (params[0].value) + " Kwh<br />" +
								'水泵：' + (params[1].value) + " Kwh<br />" +
								'冷却塔：' + (params[2].value) + " Kwh"
							}else{
								showText = params[0].name + '日' + "<br />" +
								'空调：' + (params[0].value) + " Kwh<br />" +
								'水泵：' + (params[1].value) + " Kwh<br />" +
								'冷却塔：' + (params[2].value) + " Kwh"
							}
							return showText;
						}
					},
					legend: {
						show: true,
						orient: 'horizontal',
						x: 'center',
						top: 0,
						textStyle: {
							fontSize: 12,
							fontWeight: 'bold',
							color: '#fff'
						},
					},
					xAxis: {
						type: "category",
						data: this.chartData[0],
						axisLabel: {
							show: true,
							textStyle: {
								color: '#fff'
							}
						},
						axisTick: {
							show: false
						}
					},
					yAxis: {
						type: "value",
						axisLabel: {
							formatter: function(value) {
								if (value >= 1000) {
									value = value / 1000 + "k";
								} else if (value < 1000) {
									value;
								}
								return value;
							},
							textStyle: {
								color: '#fff'
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#323232',
								type: "dashed"
							}
						}
					},
					series: [{
						type: "bar",
						name: "空调",
						stack: true,
						data: this.chartData[1],
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
									offset: 0,
									color: "#30CEEF"
								}, {
									offset: 1,
									color: "#317FEF"
								}], false)
							}
						},
						barMaxWidth: 50
					},{
						type: "bar",
						name: "水泵",
						stack: true,
						data: this.chartData[2],
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
									offset: 0,
									color: "#31DCE7"
								}, {
									offset: 1,
									color: "#43F0B7"
								}], false)
							}
						},
						barMaxWidth: 50
					},{
						type: "bar",
						name: "冷却塔",
						stack: true,
						data: this.chartData[3],
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
									offset: 0,
									color: "#BCE4FB"
								}, {
									offset: 1,
									color: "#86CBF3"
								}], false)
							}
						},
						barMaxWidth: 50
					}],
				};
			
				this.chart.setOption(option);
			},
			getNowTime() {
				var date = new Date();
				var year = date.getFullYear();
				var currentdate = year;
				// console.log(currentdate)
				return currentdate;
			},
			changeYear() {
				this.isYear = true
			},
			changeMonth() {
				this.isYear = false
			}
		},

		destroyed() {
			window.onresize = null;
		},
	};
</script>

<style lang="scss">
	#energyRightTop {
		height: 5.8rem;
		width: 14.825rem;
		
		.box-head{
			.el-input__icon{
				line-height: 0;
			}
			.block{
				height: 0.375rem;
			}
		}
		
		.box-content{
			width: 100%;
			height: 4.5rem;
			.left{
				width: 25%;
				p{
					font-size: 0.1875rem;
				}
				span{
					font-size: 0.1625rem;
				}
				.show{
					display: inline-block;
					width: 1.5rem;
					height: 0.375rem;
					font-size: 0.3125rem;
					background-image: linear-gradient(#1C658C, #2C3333, #1C658C);
					color: #fff;
					border-radius: 2px;
					text-align: center;
					line-height: 0.375rem;
				}
				.list>div{
					height: 0.8125rem;
					.listText{
						display: inline-block;
						width: 1.25rem;
						font-size: 0.2125rem;
					}
				}
			}
			.right{
				width: 70%;
			}
		}
		
		.el-input__inner {
			background: none;
			width: 2rem;
			height: 0.375rem;
			line-height: 0;
			border: dimgray solid 1px;
			border-radius: 3px;
			color: #fff;
		
			.el-range-input {
				background: none;
				color: #fff;
			}
		
			.el-range-separator {
				color: #fff;
				margin-right: 8px;
			}
		}
		
		.el-button {
			// width: 0.75rem;
			height: 0.375rem;
			line-height: 0;
			background-color: rgba(255, 255, 255, 0);
			border: gray solid 1px;
			color: #fff;
		}

		.el-button--primary {
			background-color: #409EFF;
			border: 0;
		}
	}
</style>
